import { Box, Paper, Typography, Grid2 } from "@mui/material";
import Header from "../../components/Header";
import BranchWiseMemberCount from "./branchwise_member_count";
import MembersByDiscipline from "./disciplinewise_member_count";

const Dashboard = () => {
  return (
    <Box m={{ xs: "12px", sm: "16px", md: "20px" }}>
      <Header title="Admin Dashboard" subtitle="Analytics Overview" />

      {/* Using Grid2 for two charts per row */}
      <Grid2 container spacing={{ xs: 2, md: 2.5 }}>
        {/* First Row - Member Count by Discipline and Branch-wise Member Count */}
          <Grid2 size={{ xs: 12, lg: 6 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 1.5, sm: 2, md: 2.5 },
              borderRadius: 2,
              height: "100%",
            }}
          >
            <Typography variant="h6" mb={1.5} sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}>
              Total members for each discipline
            </Typography>
            <MembersByDiscipline />
          </Paper>
        </Grid2>
          <Grid2 size={{ xs: 12, lg: 6 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 1.5, sm: 2, md: 2.5 },
              borderRadius: 2,
              height: "100%",
            }}
          >
            <Typography variant="h6" mb={1.5} sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}>
              Total members for each branch
            </Typography>
            <BranchWiseMemberCount />
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Dashboard;